export default __webpack_public_path__ + "static/media/flag_no.14b4249f.svg";